<template>
  <v-container class="service-down">
    <v-row no-gutters style="height: 100vh;">
      <v-col :align-self="'center'" justify-center class="text-center">
        <div class="text-vertical-center text-center">
          <img width="300px" style="margin: 0 auto;" src="logo.svg" />
          <h1>Il servizio non &egrave; al momento disponibile</h1>
          <h3>Ci scusiamo per il disagio!</h3>
          <h4>Ti invitiamo a ricaricare la pagina tra qualche minuto.</h4>
          <h5>non puoi aspettare? contattaci</h5>
          <h3>Telefono +39 045 8782333</h3>
          <router-link
            color="primary"
            style="text-decoration: none"
            :to="{ name: 'Home' }"
          >
            TORNA ALLA HOMEPAGE
          </router-link>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "NotFound"
};
</script>
<style lang="scss" scoped>
html,
body {
  width: 100% !important;
  height: 100% !important;
}
body {
  margin: 0 !important;
}
</style>
